import type { TrackingContextValue } from '@swf/core/providers/TrackingContext';

import { GAEvent } from './utils';

export const twitchConnected = (tracking: TrackingContextValue) =>
  GAEvent({ action: 'Twitch Connected' }, tracking);

export const twitchDisconnected = (tracking: TrackingContextValue) =>
  GAEvent({ action: 'Twitch Disconnected' }, tracking);
